import exitTaskViewModal from '@/locales/en/exitTaskViewModal.json';
import homeownerExperience from '@/locales/en/homeownerExperience.json';
import installerExperience from '@/locales/en/installerExperience.json';
import {
  loadLocaleModules,
  loadSharedEsMessages,
  type LocaleMessageLoaders,
  type LocaleModule,
  sharedEnI18n
} from '@shared/i18n';
import { createI18n } from 'vue-i18n';

export const localeMessageLoaders: LocaleMessageLoaders = {
  es: async () => {
    const [shared, app] = await Promise.all([
      loadSharedEsMessages(),
      loadLocaleModules(import.meta.glob<LocaleModule>('./locales/es/*.json'))
    ]);
    return { ...shared, ...app };
  }
};

export default createI18n({
  legacy: false,
  locale: 'en', // default language
  fallbackLocale: 'en', // fallback language in case a translation is not found
  messages: {
    en: {
      ...sharedEnI18n,
      ...exitTaskViewModal,
      ...homeownerExperience,
      ...installerExperience
    }
  }
});
